import {useAppSelector} from "./reduxHooks.ts";
import {useTranslation} from "react-i18next";
import {useConfirmDialog} from "./useConfirmDialog.tsx";

const useDirtyLeaveCheck = () => {
    const {t} = useTranslation();
    const dirtyState = useAppSelector(state => state.navigation);
    const {confirm, dialog} = useConfirmDialog();

    const isAnyDirty = () => Object.values(dirtyState).some(Boolean);

    const denyDirtyLeave = async (): Promise<boolean> => {
        if (!isAnyDirty()) return false;
        const accepted = await confirm({
            message: t("defaults.confirmLeave"),
            confirmLabel: t("defaults.leaveConfirm"),
            cancelLabel: t("defaults.leaveStay"),
            danger: true,
        });
        return !accepted;
    };

    return {denyDirtyLeave, dialog};
};

export default useDirtyLeaveCheck;
